import { render, staticRenderFns } from "./informationDetails.component.vue?vue&type=template&id=4aef8bd4"
import script from "./informationDetails.component.ts?vue&type=script&lang=ts&external"
export * from "./informationDetails.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aef8bd4')) {
      api.createRecord('4aef8bd4', component.options)
    } else {
      api.reload('4aef8bd4', component.options)
    }
    module.hot.accept("./informationDetails.component.vue?vue&type=template&id=4aef8bd4", function () {
      api.rerender('4aef8bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/informationDetails/informationDetails.component.vue"
export default component.exports